export enum APIEndpoints {
    /** A post-request is required when using this URL. */
    AlphabetPlanetCategoryTree = "https://www.creaza.com/ICSXapi/exercise/GetAlphabetPlanetCategory",
    /** Used as the url in a get-request. */
    Exercises = "https://www.creaza.com/ICSXapi/exercise/List?",
    /** GET */
    MGMTTranslations = "https://www.creaza.com/ICSXapi/captions/GetAppCaptions?namespace=abpapp",
    /** GET */
    AssignmentVerifyInvitation = "https://www.creaza.com/ICSXapi/assignment/VerifyInvitation?"
}